(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  let pending = false;
  function update() {
    pending = false;
    const chat = document.querySelector('shopify-chat');
    const roots = [];
    function findButton(root) {
      if (!root) return null;
      roots.push(root);
      const found = root.querySelector('[part="activator"]');
      if (found) return found;
      for (const element of root.querySelectorAll('*')) {
        const nested = findButton(element.shadowRoot);
        if (nested) return nested;
      }
      return null;
    }
    const button = findButton(chat?.shadowRoot);
    const buttonRoot = button?.getRootNode();
    if (!chat || !button) return;
    if (!buttonRoot.querySelector('#hemmaspa-side-position')) {
      const style = document.createElement('style');
      style.id = 'hemmaspa-side-position';
      style.textContent = '@media (max-width:749px) { .activator__label { display:none!important; } .activator { display:flex!important; justify-content:center!important; align-items:center!important; gap:0!important; } }';
      buttonRoot.append(style);
    }
    if (!mobile.matches || button.getAttribute('aria-expanded') === 'true') {
      chat.classList.remove('hemmaspa-chat-obstructed');
      return;
    }
    const r = button.getBoundingClientRect();
    const controls = document.querySelectorAll('product-form button, .shopify-payment-button, shopify-accelerated-checkout, #more-payment-options-link');
    const overlaps = Array.from(controls).some(control => {
      const c = control.getBoundingClientRect();
      return c.width > 0 && c.height > 0 && c.left < r.right + 8 && c.right > r.left - 8 && c.top < r.bottom + 8 && c.bottom > r.top - 8;
    });
    chat.classList.toggle('hemmaspa-chat-obstructed', overlaps);
  }
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(update);
  }
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule, {passive: true});
  mobile.addEventListener('change', schedule);
  new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true});
  const sizes = new ResizeObserver(schedule);
  const main = document.querySelector('main');
  if (main) sizes.observe(main);
  let attempts = 0;
  const startup = window.setInterval(() => {
    schedule();
    if (++attempts >= 20) window.clearInterval(startup);
  }, 500);
  schedule();
  window.addEventListener('load', schedule, {once: true});
})();
